'use client';

import { clsx } from 'clsx';
import { PropsWithChildren, useEffect, useState } from 'react';

import { useScrollProgress } from '@monoimin/hooks';

type MeetingWrapperProps = PropsWithChildren<{
  className?: string;
}>;

export const MeetingWrapper = ({
  children,
  className,
}: MeetingWrapperProps) => {
  const [isProgramBlokExist, setProgramBlokExist] = useState(false);

  useEffect(() => {
    setProgramBlokExist(
      Boolean(document.getElementById('real-estate-program'))
    );
  }, []);

  const isScrolled = useScrollProgress({ start: 1500 });

  const makeSticky = !isProgramBlokExist || (isProgramBlokExist && isScrolled);

  return (
    <div className={clsx(className, makeSticky && 'lg:sticky lg:top-20')}>
      {children}
    </div>
  );
};
